import request, { appendApiUrl } from '@/utils/request'
import { deleteEmpty } from './common.js'
import { pwSet_mock, success_mock } from './mock'

const http_request_mode = '' // 是否启用mock

// 是否设置支付密码
// {
//     "email": "",
//     "password": "",
//     "userId": ""
// }
export function checkPasswordIsSet(options = {}) {
  if (http_request_mode === 'mock') {
    return pwSet_mock(false)
  }
  return request.postJson({
    url: '/api/account/password/exist',
    data: { ...deleteEmpty(options) },
  })
}

// 设置支付密码
// {
//     "email": "",
//     "password": "",
//     "userId": ""
// }
export function setPayPassword(options = {}) {
  if (http_request_mode === 'mock') {
    return success_mock()
  }
  return request.postJson({
    url: '/api/account/password/create',
    data: { ...deleteEmpty(options) },
  })
}

// 修改支付密码
// {
//     "passwordNew": "",
//     "passwordOld": "",
//     "userId": ""
// }
export function updatePayPassword(options = {}) {
  return request.postJson({
    url: '/api/account/password/update',
    data: { ...deleteEmpty(options) },
  })
}

/** 发送验证码
 * @param
		{
				"effectiveTime": 0,
		    "sceneCode": 1, // 业务场景类型 1.钱包绑定验证 2.钱包修改密码 3:更换邮箱时验证当前邮箱 4:更换邮箱时给新邮箱发验证码
				"touchAddress": "", // 触达地址
				"touchType": 0, // 触达类型 1邮箱 2短信
				"userId": ""  // 非必填
		}
 * @returns
		{
				codeId: "" // 验证码id
		}
 */
export function sendCode(options = {}) {
  if (http_request_mode === 'mock') {
    return success_mock()
  }
  return request.postJson({
    url: '/api/verify/code/send',
    data: { ...deleteEmpty(options) },
  })
}

/**
 * @description: 校验验证码,绑定或更新触达地址、
 * @URL: https://staging-dev1-oversea-api.toplupe.com/api/doc.html#/default/%E9%AA%8C%E8%AF%81%E7%A0%81/verifyVerificationCodeUsingPOST
 */
export function bindOrUpdate(options = {}) {
  return request.postJson({
    url: '/api/verify/code/bindOrUpdate',
    data: { ...deleteEmpty(options) },
  })
}

/**
 * @description: 获取特定的优惠券信息
 * @URL: https://staging-dev1-oversea-api.toplupe.com/api/doc.html#/default/%E8%A3%82%E5%8F%98%E6%B4%BB%E5%8A%A8%E6%8E%A5%E5%8F%A3/getCertainCouponUsingGET
 */
export function getCertainCoupon(options = {}) {
  const {
    checkSaved = '',
    country = '',
    kicoinId = '',
    specialActivityId = '',
  } = options
  return request.get({
    url: appendApiUrl(
      `/activity/get/certain/coupon?checkSaved=${checkSaved}&country=${country}&kicoinId=${kicoinId}&specialActivityId=${specialActivityId}`
    ),
  })
}
